import { HDNode } from 'ethers/utils'

export function isValidMnemonic(mnemonic) {
  return HDNode.isValidMnemonic(mnemonic)
}

export function extractWalletFromHistory(history) {
  if (history.location && history.location.state) {
    return history.location.state.wallet || {}
  }

  return {}
}


// WEBPACK FOOTER //
// ./src/util/wallet.js